import {useState} from "react";
import {DateRangePicker} from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import es from "date-fns/locale/es";

import defaultStaticsRangeLocales from "./defaultStaticsRangeLocales";
import defaultInputsRangeLocales from "./defaultInputsRangeLocales";

const DataRange = ({rangeData, maxDate = null, maxSpan = null}) => {
    const [state, setState] = useState({
        selection: {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    });

    const handleSelect = (ranges) => {
        if (maxSpan) {
            const {startDate, endDate} = ranges.selection;
            const diffTime = Math.abs(endDate - startDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays > maxSpan) {
                const newEndDate = new Date(startDate);
                newEndDate.setDate(startDate.getDate() + (maxSpan - 1));
                // Restamos 1 para obtener exactamente 30 días incluyendo el día inicial
                ranges.selection.endDate = newEndDate;
            }
        }

        setState({
            ...state,
            selection: ranges.selection,
        });
        const {startDate, endDate} = ranges.selection;
        const newStartDate = new Date(startDate.setHours(0, 0, 0, 0));
        const newEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        rangeData(newStartDate, newEndDate);
    };
    const defaultStaticRangeLocale = defaultStaticsRangeLocales("es");
    const defaultInputRangesLocale = defaultInputsRangeLocales("es");

    const filteredStaticRanges = maxSpan
        ? defaultStaticRangeLocale.filter((range) => {
              const rangeObj = range.range();
              const diffTime = Math.abs(rangeObj.endDate - rangeObj.startDate);
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              return diffDays <= maxSpan;
          })
        : defaultStaticRangeLocale;

    const maxSpanValue = maxSpan ? {days: maxSpan} : undefined;

    return maxDate ? (
        <DateRangePicker
            ranges={[state.selection]}
            maxDate={maxDate}
            maxSpan={maxSpanValue}
            onChange={handleSelect}
            locale={es}
            staticRanges={filteredStaticRanges}
            inputRanges={[...defaultInputRangesLocale]}
        />
    ) : (
        <DateRangePicker
            ranges={[state.selection]}
            maxSpan={maxSpanValue}
            onChange={handleSelect}
            locale={es}
            staticRanges={filteredStaticRanges}
            inputRanges={[...defaultInputRangesLocale]}
        />
    );
};

export default DataRange;
